(function () {
  'use strict';

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  async function addToCart(variantId, qty) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: Number(qty || 1) })
    });

    if (!res.ok) {
      const txt = await res.text();
      throw new Error(txt || 'Erreur ajout panier');
    }
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Impossible de lire /cart.js');
    return res.json();
  }

  // Canopy / Clean Canvas : le drawer est une section Shopify
  async function refreshSections() {
    const url = '/?sections=cart-drawer,header&ts=' + Date.now();
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) return;

    const json = await res.json();

    // 1) Remplacer le drawer
    if (json['cart-drawer']) {
      const tmp = document.createElement('div');
      tmp.innerHTML = json['cart-drawer'];

      const newDrawer = tmp.querySelector('#shopify-section-cart-drawer') || tmp.firstElementChild;
      const oldDrawer = document.querySelector('#shopify-section-cart-drawer');

      if (newDrawer && oldDrawer) oldDrawer.replaceWith(newDrawer);
    }

    // 2) Remplacer l’icône panier dans le header si possible
    if (json['header']) {
      const tmp2 = document.createElement('div');
      tmp2.innerHTML = json['header'];

      const newIcon =
        tmp2.querySelector('#cart-icon-bubble') ||
        tmp2.querySelector('.cart-summary') ||
        tmp2.querySelector('.cart-count-bubble');

      const oldIcon =
        document.querySelector('#cart-icon-bubble') ||
        document.querySelector('.cart-summary') ||
        document.querySelector('.cart-count-bubble');

      if (newIcon && oldIcon) oldIcon.replaceWith(newIcon);
    }
  }

  function stopAll(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
  }

  async function handleAdd(form, btn) {
    const variantId =
      (btn && btn.getAttribute('data-variant-id')) ||
      form.getAttribute('data-variant-id') ||
      (form.querySelector('input[name="id"]') ? form.querySelector('input[name="id"]').value : '');

    const qty =
      (form.querySelector('input[name="quantity"]') ? form.querySelector('input[name="quantity"]').value : 1);

    if (!variantId) {
      alert('Variant ID manquant');
      return;
    }

    const oldText = btn ? btn.textContent : null;
    if (btn) { btn.disabled = true; btn.textContent = 'AJOUT...'; }

    try {
      await addToCart(variantId, qty);

      // maj compteur via cart.js
      const cart = await getCart();

      // rafraîchir sections (drawer + header)
      await refreshSections();

      // fallback: si compteur est juste un texte quelque part
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #CartCount').forEach(el => {
        el.textContent = String(cart.item_count);
      });

    } catch (err) {
      console.error(err);
      alert("Erreur ajout panier. Ouvre Console (F12) pour voir l'erreur.");
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = oldText; }
    }
  }

  // 1) Intercepter CLICK sur le bouton
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quote-atc-btn');
    if (!btn) return;

    const form = closest(btn, 'form.quote-product-form');
    if (!form) return;

    stopAll(e);
    handleAdd(form, btn);
  }, true);

  // 2) Intercepter SUBMIT (au cas où)
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form.quote-product-form');
    if (!form) return;

    const btn = form.querySelector('.quote-atc-btn');
    stopAll(e);
    handleAdd(form, btn);
  }, true);

})();